module.exports = __webpack_public_path__ + "static/img/img-Analysis1.c5ae513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-Analysis1.png
// module id = s3PP
// module chunks = 1